<template>
  <v-select
    :value="value"
    :items="items"
    item-text="description"
    item-value="code"
    multiple
    dense
    outlined
    hide-details
    :class="[
      'facet-chip-select',
      selectClass,
      dirty ? 'pdp-input--dirty' : null,
    ]"
    :placeholder="placeholder"
    :menu-props="{ offsetY: true, maxHeight: 320 }"
    @input="$emit('input', $event)"
  >
    <template #selection="{ item }">
      <v-chip
        small
        close
        class="ma-1 facet-select-chip"
        @click:close="$emit('remove', resolveItem(item).code)"
      >
        <v-btn
          v-if="showPrimary && value.length > 1"
          icon
          x-small
          tabindex="-1"
          class="facet-select-chip-star"
          :aria-label="
            'Set as favorite ' + label + ': ' + resolveItem(item).description
          "
          @click.stop="$emit('set-primary', resolveItem(item).code)"
        >
          <v-icon x-small>
            {{
              resolveItem(item).code === primaryCode
                ? "mdi-star"
                : "mdi-star-outline"
            }}
          </v-icon>
        </v-btn>
        <span
          class="facet-select-chip__text"
          :title="resolveItem(item).description"
          >{{ resolveItem(item).description }}</span
        >
      </v-chip>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "FacetChipSelect",
  props: {
    value: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    showPrimary: { type: Boolean, default: false },
    primaryCode: { type: String, default: "" },
    label: { type: String, default: "" },
    placeholder: { type: String, default: undefined },
    selectClass: { type: String, default: "facet-select" },
    /** Highlight outlined field when value differs from loaded snapshot */
    dirty: { type: Boolean, default: false },
  },
  methods: {
    resolveItem(raw) {
      const code =
        raw != null && typeof raw === "object" && raw.code != null
          ? String(raw.code)
          : String(raw != null ? raw : "");
      const row = (this.items || []).find((x) => String(x.code) === code);
      return {
        code,
        description:
          row && row.description != null
            ? String(row.description)
            : code || "—",
      };
    },
  },
};
</script>

<style scoped>
/* Match ProductEditView: tint only the outlined control */
.pdp-input--dirty >>> .v-input__slot {
  background-color: rgba(25, 118, 210, 0.08) !important;
}
.facet-chip-select >>> .v-select__selections {
  flex-wrap: wrap;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
/* Constrain each chip to row width so label ellipsizes before the close control */
.facet-chip-select >>> .v-chip.facet-select-chip {
  max-width: 100%;
  min-width: 0;
  display: inline-flex;
  vertical-align: middle;
}
.facet-chip-select >>> .v-chip.facet-select-chip .v-chip__content {
  display: flex;
  align-items: center;
  min-width: 0;
  max-width: 100%;
  flex: 1 1 auto;
}
.facet-chip-select >>> .facet-select-chip__text {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.facet-chip-select >>> .v-chip__close {
  flex-shrink: 0 !important;
}
.facet-chip-select >>> .facet-select-chip-star {
  flex-shrink: 0 !important;
}
</style>
